<template>
  <div id="cme-header">
    <div class="nav-center header"
         v-if="$store.state.tagData.indexOf('ext_wz_logo')>-1">
      <div class="z-container"
           @contextmenu.prevent="$emit('windowRightMenu',$event,'header')"
           @touchstart="$emit('touchstart',$event,'header')"
           @touchmove="$emit('touchmove')"
           @touchend="$emit('touchend')">
        <div class="logo"
             v-if="tagData.indexOf('ext_wz_logo_img')>-1">
          <div style="display:flex;">
            <a  style="display:flex;align-items: center;" @click="jumpToEdit()">
              <div class="picture"
                   :style="{backgroundImage:logoImg}"></div>
              <!-- <div class="picture"
                   :style="{backgroundImage:logo.mainLogoImg?`url(${logo.mainLogoImg})`:(!logo.mainLogoName&&!logo.mainLogoImg ? url(require('../assets/logo.png')):'')}"></div> -->
              <div class="mainLogo">
                <div>
                  <div class="mainLogoName">
                    <span>{{logo.mainLogoName}}</span>
                  </div>
                </div>
                <div class="mainLogoEnName">
                  <span>{{logo.mainLogoEnName}}</span>
                </div>
              </div>
            </a>
            <a :href="urlJump"
                style="flex-shrink:0;"
               v-if="tagData.indexOf('ext_wz_metaverse')>-1">
              <!-- 添加响应式 -->
              <div class="Metaverse">
                <div>
                  <span>元宇宙</span>
                </div>
                <div class="MetaverseUrl">{{url}}</div>
              </div>
            </a>
          </div>
          <!-- 下拉框 -->
          <div class="selcctChoice"
               :style="{'top':url?'':'7px'}"
               v-if="tagData.indexOf('ext_wz_metaverse')>-1">
            <img v-if="!$store.state.NewYearTheme" src="~@/assets/image/images/open_icon.png"
                 alt=""
                 @click.stop.prevent="selectDesp();">
            <!-- 过年主题 -->
            <img v-else src="~@/assets/image/images/open_icon_white.png"
                 alt=""
                 @click.stop.prevent="selectDesp();">
            <div class="selects"
                 v-show="selectDes">
              <span>
                <input type="text"
                       ref="input_des"
                       v-model="inputCon"
                       @click.stop.prevent="">
              </span>
              <ul>
                <li v-show="hasLogin"
                    class="changeColors"
                    @click="jumpUrl(-2)">我的客户端</li>
                <dropdownLeave v-for="(item,index) in infoName" :key="index" :Str="item" :inputCon="inputCon"></dropdownLeave>
                <li v-show="noResults">No results found</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="navbar-box"
             v-if="tagData.indexOf('ext_wz_serch')>-1">
          <div class="navbar-icon"
               v-show="isPcCient"
               @click="showmask = true">
            <a href="javascript:;"
               @click="showmask = true"></a>
          </div>
          <div class="navbar-mask"
               v-show="showmask"></div>
          <ul class='navbar'
              ref="navbarUl"
              style="position:relative;lineHeight:32px;">
            <template v-if="tagData.indexOf('ext_wz_main_nav')>-1">
              <span :class="['navbar-libox',isPcCient?'phone':'']"
                    :style="{display:(showmask || !isPcCient)?'inline':'none'}">
                <div class="close"
                     @click="showmask = false"><img src="~@/assets/image/images/icons/demo_close.png"></div>
                <!-- <li class="li nav"
                    v-if="(isPcCient || !mainNavListMore.length)&&logo.mainLogoName && logo.mainLogoName.indexOf('千业律师') == -1"> -->
                <!-- <li class="li nav"
                    v-show="logo.mainLogoName && logo.mainLogoName.indexOf('千业律师') == -1&&windowWidth>421">
                  <a href="https://520emv.com/uoqid/?appId=zjsqe">首页
                  </a>
                </li> -->
                <li class="li nav"
                    v-for="mainNav in tempMainNavList"
                    :key="mainNav.id"
                    @click.prevent="openWin(mainNav)">
                  <a href="javascript:;">
                    {{mainNav.name}}
                  </a>
                </li>
                <li class="li nav">
                  <span class="plus-icon"
                    v-if="tagData.indexOf('ext_wz_serch')>-1"
                    @click.stop="jumpconfiguration()">
                  </span>
                </li>
              </span>
            </template>
            <li class="li nav more"
                    v-show="mainNavListMore.length"
                    @click.stop.prevent="popShow('mainMoreShow')">
                <a href="javascript:;">
                  更多
                </a>
            </li>
            <li class="nav-search">
              <span class="search-icon"
                v-if="tagData.indexOf('ext_wz_serch')>-1"
                @click.stop="handleFocus()">
                <div v-show="searchTopBoxShow"
                 class="assistantMoreS mainMoreS searchBox" style="top:50px">
                 <div class="searchBox-input">
                    <input type="text" @click.stop='' placeholder="请输入关键字搜索" v-model="keyWord" @keyup.enter="getContent();" />
                    <span @click.stop="getContent();"></span>
                 </div>
                  <div class="child-menu-search" v-show="haveChildMenu.length">
                    <div class="child-menu_list">
                      <div class="menuitem"
                          v-for="(item,ind) in haveChildMenu"
                          @click.prevent="open(item.contentDsfWzUrl)"
                          :key="ind">
                        <span>{{item.name}}</span>
                      </div>
                  </div>
                </div>
              </div>
              </span>
            </li>
            <div v-show="mainMoreShow"
                 class="mainMoreS">
              <div class="more-menu"
                   style="overflow:auto">
                <div class="more-child">
                  <div class="child-menu">
                    <div class="child-menu__wrap">
                      <div class="child-menu_list">
                        <div class="menuitem"
                             v-for="mainMore in mainNavListMore"
                             @click.prevent="openWin(mainMore)"
                             :key="mainMore.id">
                          <span>{{mainMore.name}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ul>
        </div>
        <div class="clear"></div>
        <!-- 悬浮层 -->
        <div class="popover"
             :style="{top:contTop+'px',left:contLeft+'px'}"
             v-show="popoverShow"
             @mouseenter="popoverShow=true;subChildrenShow=true;"
             @mouseleave="leavePopover();">
          <div class="popoverWhite">
            <span>
              <input v-model="inputCons">
            </span>
            <div>
              <headerSuspensions :content="flowNavList"
                                 :inputCons="inputCons"
                                 v-if="flowNavList"
                                 ref="Suspension"></headerSuspensions>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 智能商城 -->
    <div class="subnav"
         v-if="tagData.indexOf('ext_wz_sub_nav')>-1">
      <div class="z-container"
           @contextmenu.prevent="$emit('windowRightMenu',$event,'header')"
           @touchstart="$emit('touchstart',$event,'header')"
           @touchmove="$emit('touchmove')"
           @touchend="$emit('touchend')"
           style="text-align: left;">
        <div class="left">
          <div class="leftBox">
            <template v-if="isPcCient2||(!isPcCient2&&!showIcon)">
              <div class="menuBar"
              @mouseleave="subChildrenShow=false,subInd=-1"
                   :style="{marginLeft:marginLeft+'px'}">
                <menuBar v-for="(sub,ind) in mainMoreShowList"
                         :key="ind"
                         ref="spanItems"
                         :sub="sub"
                         :index='ind'
                         :refeshMenus="refeshMenus"></menuBar>
                <span class="li" v-for="item in subNavList" :key="item.id">
                  <a :href="'javascript:;'"
                    @mouseenter="handleEnterSubNav(item)">
                    <img :src="require('../assets/image/images/icons/sub_icon_menu.jpg')" />
                    {{item.name}}
                  </a>
                </span>
              </div>
            </template>
          </div>
          <span class="navigationConfig">
            <!-- 配置 -->
            <span class="navigationConfig-l" @click.stop="jumpconfiguration('t')"></span>
            <span class="navigationConfig-line"></span>
            <!-- 搜索 -->
            <span class="navigationConfig-r" ref="search" @click.stop="searchShowOrNot()" >
              <div v-show="searchBoxShow"
                 class="assistantMoreS mainMoreS searchBox" :style="{right:`${-rightS}px`}">
                 <div class="searchBox-input">
                    <input type="text" @click.stop='' placeholder="请输入关键字搜索" v-model="keyWord" @keyup.enter="getContent();" />
                    <span @click.stop="getContent();"></span>
                 </div>
                  <div class="child-menu-search" v-show="haveChildMenu.length">
                    <div class="child-menu_list">
                      <div class="menuitem"
                          v-for="(item,ind) in haveChildMenu"
                          @click.prevent="open(item.configData)"
                          :key="ind">
                        <span>{{item.sanbao}}</span>
                      </div>
                  </div>
                </div>
              </div>
            </span>
            <!-- 更多 -->
            <span class="navigationConfig-m" v-show="assistantNavListMore.length" @click.stop="popShow('assistantMoreShow')">更多
              <div v-show="assistantMoreShow"
                 class="assistantMoreS mainMoreS">
                <div class="more-menu"
                    style="overflow:auto">
                  <div class="more-child">
                    <div class="child-menu">
                      <div class="child-menu__wrap">
                        <div class="child-menu_list" @mouseleave="assistantMoreShow=false">
                          <div class="menuitem" 
                              v-for="(assistantMore,ind) in assistantNavListMore"
                              :key="ind">
                            <span @mouseenter="handleEnterSubNav(assistantMore, ind+wrapIndex);">{{assistantMore.name}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </span>
            
          </span>
        </div>
      </div>
    </div>
    <!-- 替换头开始 -->
    <div class="navmenu"
         ref="navmenu"
         v-show="subChildrenShow"
         @mouseleave="subChildrenShow=false,subInd=-1"
         @mouseenter="subChildrenShow=true">
      <div class="backColor">
        <div class="loading"
            v-show="loadingShow">
          <img :src="require('../assets/image/images/mxb.gif')"
              height="100%"
              alt="">
        </div>
        <div class="z-container"
            @contextmenu.prevent="$emit('windowRightMenu',$event,'header')"
            @touchstart="$emit('touchstart',$event,'header')"
            @touchmove="$emit('touchmove')"
            @touchend="$emit('touchend')">
          <div class="row"
              ref="cont"
              v-for="(second,ind) in flowChildList"
              :key="ind">
            <div class="type"
                :title="second.name" @click="changeFloorContent(second,'second')">{{second.name}}</div>
            <ul :style="{width: deviceWidth+115+'px'}">
              <li style="min-width:90px;"
                  v-for="(three,sind) in second.dataArray"
                  v-show="(three.isMore==false||(three.isMore==true&&second.showMore==true)) || (three.name=='更多'&&second.showMore==false)||(three.name=='收起'&&second.showMore==true)"
                  @mouseenter.stop.prevent="handleInsertFlowChild(three,'mainNav',$event,sind);"
                  @mouseleave="leaveTop();"
                  :key="sind">
                <a v-if="(three.isMore==false||(three.isMore==true&&second.showMore==true)||three.flowType == 'block')"
                  :href="'javascript:;'"
                  @click="changeFloorContent(three)">{{three.name}}</a>
                <a v-if="three.name=='更多'&&second.showMore==false"
                  :href="'javascript:;'"
                  @click.prevent.stop="changeFloorContent(second,'second')">{{three.name}}</a>
                <!-- <a v-if="three.name=='更多'&&second.showMore==false"
                  :href="'javascript:;'"
                  @click.prevent.stop="handleSwitchMore(second,sind,three.name)">{{three.name}}</a>
                <a v-if="three.name=='收起'&&second.showMore==true"
                  :href="'javascript:;'"
                  @click.prevent.stop="handleSwitchMore(second,sind,three.name)">{{three.name}}</a> -->
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 替换头结束 -->
  </div>
</template>
<script>
import Bus from '../bus.js'
import menuBar from './menuBar.vue'
import headerSuspensions from './headerSuspensions.vue'
import dropdownLeave from './DropdownLeave.vue'
export default {
  name: "Header",
  components: {
    Bus,
    menuBar,
    headerSuspensions,
    dropdownLeave
  },
  props: {
    flowShow: {
      default: false,
      type: Boolean
    },
    activeSubIndex: {
      default: -1,
      type: Number
    }
  },
  data () {
    return {
      logoImg: '',
      inputCons: '',
      contLeft: 0,
      loadingShow: false,
      noResults: false,
      inputCon: '',
      changeBackground: -1,
      selectDes: false,
      selectContent: [],
      //保存最初的悬浮层内容
      flowChildListFirst: false,
      content: [],
      popoverShow: false,
      contTop: 0,
      refeshMenus: false,
      urlJump: window.location.href,
      url: '',
      timeOutEvent: 0,
      subChildrenShow: false,
      navIndex: -1,
      initSubNavList:[],
      subNavList: [],
      subNavLists:[],
      thirdItem:{},
      mainMoreShowList:[],
      mainMoreShow: false,
      mainNavListMore: [],
      assistantMoreShow: false,
      assistantNavListMore:[],
      NavList:[],
      tempMainNavList: [],
      flowNavList: [],
      flowChildList: [],
      moreList: [],
      moreDrop: false,
      logo: {},
      logoUrl: "",
      marginLeft: 0,
      showIcon: false,
      dropShow: false,
      showmask: false,
      search_list: [],
      keyword: "",
      subInd: -1,
      isPcCient: false,
      screenWidth: document.documentElement.clientWidth,//屏幕宽度
      keepInd: -1,
      keepIndex: -1,
      oneLeave: [],
      cont:[],
      infoName:[],
      wrapIndex:'',
      keyWord: "",
      searchBoxShow:false,
      searchTopBoxShow:false,
      haveChildMenu:[],
      searchBoxCont:[],
      rightS:0,
      windowWidth:window.innerWidth
    };
  },
  computed: {
    moreListIndGtSix () {
      var moreListLen = this.deviceWidth;
      var fwid = 0;
      return this.moreList.filter(item => {
        fwid += item.name.length * 12 + 10 + 35;
        if (fwid < moreListLen) {
          return false;
        } else {
          return true;
        }
      });
    },
    moreListIndLtSix () {
      var fwid = 0;
      var moreListLen = this.deviceWidth;
      return this.moreList.filter(item => {
        fwid += item.name.length * 12 + 10 + 35;
        if (fwid < moreListLen) {
          return true;
        } else {
          return false;
        }
      });
    },
    isPcCient2 () {
      var flag = true;
      if (window.innerWidth <= 768) {//425
        // if (window.innerWidth) {
        flag = false;
      }
      return flag;
    },
    flowWidth () {
      var fwid = 0;
      this.flowNavList.forEach(element => {
        fwid += ((element.name.length * 12) + 22 + 35);
      });
      return fwid;
    },
    moreShow () {
      var fwid = 0;
      // if (window.innerWidth <= 1200) {
      if (window.innerWidth) {
        if (this.moreList.length > 0) {
          return true;
        } else if (this.showIcon) {
          return true;
        } else {
          return false;
        }
      } else {
        this.moreList.forEach(element => {
          fwid += element.name.length * 12 + 35;
        });
        this.subNavList.forEach(element => {
          fwid += element.name.length * 12 + 35;
        });
        // if (fwid > 900) {
        if (fwid) {
          return true;
        } else {
          return false;
        }
      }
        

    },
    deviceWidth () {
      var devicePixelWid = window.innerWidth;
      if (devicePixelWid > 1200) {
        // if (devicePixelWid) {
        return 1200 - 300;
      } else if (devicePixelWid > 768) {
        return devicePixelWid - 300;
      } else {
        return devicePixelWid - 36;
      }
    },
    tagData () {
      return this.$store.state.tagData;
    },
    hasLogin () {
      return (this.$store.state.userInfo.id || this.$store.state.userInfo.userId);
    }
  },
  watch: {
    inputCon: function (val) {
      this.cont = [];
    },
    '$store.state.creatUserId': function (val) {
      if (val && this.hasLogin) {
        this.getSelect();
      }
    },
    '$store.state.winWidth': function(val){
      this.windowWidth = val;
      this.findWrapIndex();
      if(this.searchBoxShow){
        this.searchBoxArea();
      }
      this.computedNum();
    },
    // keyWord:function(val){
    //   this.haveChildMenu = [];
    //   this.getContent(val);
    // }
  },
  mounted () {
    Bus.$on('popHide',()=>{
      this.mainMoreShow = false;
      this.searchTopBoxShow = false;
      this.assistantMoreShow = false;
      this.searchBoxShow = false;
      this.selectDes = false;
    })
    this.unwatch = this.$watch('$store.state.tagData', function(newValue, oldValue){
      this.$http
        .get(
          "/zciid-deliverable/showPlatformStyle/flow/api/get/getMainTopNavList.json",
          {
            appId: this.$appId,
            types: "main-nav",
            flowId: this.$route.query.flowId || ""
          }
        )
        .then(res => {
          if (res.state == 1) {
            this.NavList = res.data;
            this.NavList.unshift({ name: '首页', pageUrl:  location.origin + '/uoqid/?appId=' + this.$appId, flowType: 'block' });
            this.computedNum();
          }
        });
    });
    this.getSelect();
    this.getPageTitle();
    this.getLogoIcon();
    this.getSubNav();
    window.addEventListener('click', (event) => {
      this.selectDes = false;
    })
    window.addEventListener('touchstart', (event) => {
      var object = $(event.target);
      if (object.closest(".row li").length == 0 && object.closest(".popover").length == 0) {
        this.popoverShow = false;
        $('li').removeClass('backCurr');
      }
    })
    //获取浮层内容
    // this.getSuspension();
    Bus.$on('suspension', (t, b) => {
      if (t.level) {
        this.handleEnterSubNav(t, b);
      } else {
        this.subChildrenShow = false;
      }
    });
    //刷新
    Bus.$on('refeshMenu', t => {
      this.refeshMenus = t;
    });
    this.$http
      .get("/acnid-project-approve/api/process/sanbao.json", {
        identification: this.$appId
      })
      .then(res => {
        if (res.state == 1) {
          // var url = res.data.filter((tags) => tags.dataType == 'business_id').length ? res.data.filter((tags) => tags.dataType == 'business_id')[0].configData : (res.data.filter((tags) => tags.dataType == 'product_code').length ? res.data.filter((tags) => tags.dataType == 'product_code')[0].configData : '');
          var url = res.data.filter((tags) => tags.dataType == 'business_id').length ? res.data.filter((tags) => tags.dataType == 'business_id')[0].configData : '';
          if (url) {
            this.url = url;
          }

          var urlJump = res.data.filter((tags) => tags.dataType == 'show_id').length ? res.data.filter((tags) => tags.dataType == 'show_id')[0].configData : '';
          if (urlJump) {
            this.urlJump = urlJump;
          } else {
            this.urlJump = 'javascript:;'
          }
        }
      });
  },
  //跨级触发方法
  provide () {
    return {
      getId: this.getId,
      fatherMethod: this.showNoResults
    }
  },
  deactivated() {
    this.unwatch();
  },
  methods: {
    //浮层是否显示
    popShow(ite){
      if(this[ite]){
        //如果显示就隐藏
        this[ite] = false;
        window.$popShow = false;
      }else{
        if(window.$popShow){
          //为true说明有浮层显示
          Bus.$emit('popHide');
        }else{
          window.$popShow = true;
        }
        this[ite] = true;
      }
    },
    jumpToEdit(){
      if (!this.$store.state.userInfo.userId) {
        this.handleLoginAuth();
        return;
      }
      this.iframeOpen('MainFrame', 'toolsFrame', this.$store.state.baseURL + '/zciid-deliverable/business/bAppOqmidPage/init-edit?disType='+ (this.$store.state.iconAdd ? '' : 'yes') +'&pfId='+ window.$pfId+'&appId=' + this.$appId,'配置');
    },
    searchShowOrNot(){
      this.searchBoxArea();
      this.popShow('searchBoxShow');
      this.keyWord = '';
      this.haveChildMenu = [];
    },
    searchBoxArea(){
      if (this.$refs.search&&window.innerWidth<420) {
        var left = this.$refs.search.getBoundingClientRect().left + 40;
        if (left < 300) {
          this.rightS = 300 - left + (window.innerWidth-300-16)/2;
        }
      }
    },
    getContent(){
      if(!this.keyWord){
        return;
      }

      var url = '/zciid-deliverable/showPlatformStyle/flow/api/getWzAppByBlock.json',
      data={appId:this.$appId,name:this.keyWord}
      if(this.searchTopBoxShow){
        // 主导航搜索
        url = '/zciid-deliverable/api/showPlatform/content/get/getWzContentByName.json',
        data = {appId:this.$appId,keyWord:this.keyWord,pageNum:1,pageSize:100}
      }
      this.$http
        .get(url,data).then(res => {
          if (res.state == 1) {
            if(this.searchTopBoxShow){
              var arr = [];
              if(res.data){
                res.data.forEach((ele,ind)=>{
                  var ite = {};
                  ite.name = ele.name;
                  ite.contentDsfWzUrl = ele.contentWzUrl;
                  arr.push(ite);
                });
              }
              this.haveChildMenu = arr;
              this.getDsfContent(arr);
            }else{
              this.haveChildMenu = res.data;
              this.getOtherContent(res.data);
            }
          }else{
            this.haveChildMenu = [];
            if(this.searchTopBoxShow){
              this.getDsfContent([]);
            }else{
              this.getOtherContent([]);
            }
          }
        }).catch(()=>{
          this.haveChildMenu = [];
          if(this.searchTopBoxShow){
            this.getDsfContent([]);
          }else{
            this.getOtherContent([]);
          }
        })
    },
    getDsfContent(arr){
      this.$http
        .get('/zciid-deliverable/api/showPlatform/content/get/getDsfContentByName.json',{keyWord:this.keyWord}).then(res => {
          if(res.state == 1){
             this.haveChildMenu = [...arr,...res.data];
          }
        })
    },
    getOtherContent(arr){
      this.$http
        .get('/zciid-deliverable/showPlatformStyle/flow/api/getNewShelfByFlowOrBlockId.json',{
          appId: this.$appId,
          appIdStr: 'sqsjyxglzpt',
          keyWord: this.keyWord,
          pageNum: 1,
          pageSize: 100,
        }).then(res => {
          if(res.state == 1){
            var arrs=[];
            res.data.contentJsonArr.forEach((ele,ind)=>{
                  var ite = {};
                  ite.sanbao = ele.name;
                  ite.configData = ele.wzUrl;
                  arrs.push(ite);
                });
            this.getWzCass([...arr,...arrs]);
          }else{
            this.getWzCass(arr);
          }
        }).catch(()=>{
          this.getWzCass(arr);
        })
    },
    getWzCass(arr){
      this.$http
        .get('/zciid-deliverable/api/showPlatform/content/getWzCassAppByDataType.json',{
          dataType: 'gx',
          keyWord: this.keyWord,
          pageNum: 1,
          pageSize: 100,
        }).then(res => {
          if(res.state == 1){
            console.log(res.data);
            var arrs=[];
            res.data.forEach((ele,ind)=>{
                  var ite = {};
                  ite.sanbao = ele.name;
                  ite.configData = ele.pageUrl;
                  arrs.push(ite);
                });
            this.haveChildMenu = [...arr,...arrs];
          }else{
            this.haveChildMenu = arr;
          }
        }).catch(()=>{
          this.haveChildMenu = arr;
        })
    },
    findWrapIndex() {
      var width = 0,wrapIndex=this.subNavLists.length + 3,scales=0,windowWidth=0;
      if (document.getElementById('app').style.transform) {
        scales = document.getElementById('app').style.transform.slice(6, -1);
        windowWidth = (window.innerWidth-16)/scales;
      }else{
        windowWidth = window.innerWidth-16;
        if(windowWidth>1200){
          windowWidth = 1200;
        }
      }
      
      for (let i = 0; i < this.initSubNavList.length; i++) {
        const spanWidth = this.initSubNavList[i].name.length * 12 + 38;
        width += spanWidth;
      }
      //计算能放几个优先级流程
      for (let t = 0; t < this.subNavLists.length; t++) {
        const spanWidths = this.subNavLists[t].name.length * 12 + 16;
        width += spanWidths;
        if(width + 150 > windowWidth){
          wrapIndex = t;
          break;
        }
      }
      //记录能放几个优先级流程，切掉放不下的放在更多
      if(this.wrapIndex !== wrapIndex){
        this.mainMoreShowList = this.subNavLists.slice(0,wrapIndex);
        this.assistantNavListMore = this.subNavLists.slice(wrapIndex,this.subNavLists.length);
        this.wrapIndex = wrapIndex ;
      }
      //优先级都没有的时候开始隐藏常显流程
      if(window.innerWidth<487 && this.subNavList.length == 3){
        this.subNavList.pop();
        this.assistantNavListMore.unshift(this.thirdItem);
      }else if( window.innerWidth>=487 && this.subNavList.length == 2){
        if(this.thirdItem){
          this.subNavList.push(this.thirdItem);
          this.assistantNavListMore.shift(this.thirdItem);
        }
      }
    },
    jumpconfiguration(t){
      if (!this.$store.state.userInfo.userId) {
        this.handleLoginAuth();
        return;
      }
      if(this.$store.state.rightType != '534'){
        this.$notify({
          title: '提示',
          message: '暂无权限',
          type: 'warning',
          duration: 5000
        });
        return;
      }
      var types = 'main-nav';
      if(t){
        types = 'sub-nav-priority'
      }
      this.iframeOpen('MainFrame', 'toolsFrame', this.$store.state.baseURL + '/zciid-deliverable/app/api/config/select/flow/data?resourceAppId='+ this.$appId + '&types='+ types +'&appId=' + this.$appId+'&pfId='+ window.$pfId,'配置')
    },
    showNoResults(t){
      if(t){
        this.cont.push(t);
      }
      if(this.cont.length){
        this.noResults = false; 
      }else{
        this.noResults = true; 
      }
    },
    changeFloorContent (three,second) {
      // Bus.$emit('changeFloorContent', three);
      if(second){
        var data={ appId: this.$appId,appIdStr:three.appId, flowOrBlockId:three.id,flowLitName:three.name};
        // this.$router.push({ path: 'flowList', query: data});
        this.routerJump('push','flowList',data,second.name);
      }else if(three.pageUrl){
        // window.location.href = three.pageUrl
        this.open(three.pageUrl,'_self',three.name);
      }
    },
    jumpUrl (url) {
      //点击我的客户端
      if (url == -2) {
        var link = window.location.origin + '/aassid';
        this.open(link, '_blank','我的客户端');
        return;
      }
      if (url) {
        this.open(url, '_blank','我的客户端');
        this.selectDes = false;
      } else {
        this.$notify({
          title: '提示',
          message: '暂无外展',
          type: 'warning',
        });
      }
    },
    //改变背景色
    changeBackge (ind) {
      this.changeBackground = ind;
    },
    //点击出现下拉框，并获取焦点
    selectDesp () {
      this.popShow('selectDes');
      setTimeout(() => {
        this.$refs.input_des.focus();
      }, 100)
    },
    //获取下拉框内容
    getSelect () {
      var url = '/aassid/cms/client/api/platform/sanbao/datatype.json',
      data={userId: this.$store.state.userInfo.userId}
      if(window.location.hostname.indexOf('520ezj') > -1){
        url = '/zciid-deliverable/showPlatformStyle/flow/api/getWzAppByBlock.json',
        data={appId:this.$appId}
      }
      this.$http
        .get(url,data).then(res => {
          if (res.state == 1) {
            res.data.forEach((item,ind)=>{
              item.name = item.sanbao;
              item.clientUrl = item.configData;
            })
            this.infoName = res.data;
          }
        })
    },
    //计算高度
    getTop (ev, ind, sub) {
      if (sub.name == '更多' || sub.name == '收起') return;
      //记录初始内容
      // if (this.flowChildListFirst) {
      //   this.flowChildList = JSON.parse(sessionStorage.getItem('flowChildListFirst'));
      //   this.flowChildListFirst = false;
      // }
      //改变悬浮层行数
      this.suspensionInd = ind;
      //离开li时保留hover状态
      $('li').removeClass('backCurr');
      $(ev.target).siblings().removeClass('backCurr');
      $(ev.target).addClass('backCurr');
      //判断是否超出底部悬浮层高度，底部悬浮层高度-li距离浮层高度 + 浮层滚动高度
      var distance = this.$refs['navmenu'].offsetHeight - $(ev.target).position().top + this.$refs['navmenu'].scrollTop >= 37;
      //距离浮层顶部高度 + header高度 = 相对header组件的高度
      this.contTop = $(ev.target).position().top + 124 + document.documentElement.scrollTop - this.$refs['navmenu'].scrollTop;
      //距离浮层左侧距离 - padding - （浮层宽度 - li的宽度）/ 2
      this.contLeft = $(ev.target).position().left - 10 - (158 - $(ev.target)[0].offsetWidth) / 2 - this.$refs['navmenu'].scrollLeft;
      if (window.innerWidth > 1200 && window.innerWidth <= 1217 || window.innerWidth < 768) {
        this.contLeft = $(ev.target).position().left - (158 - $(ev.target)[0].offsetWidth) / 2 - this.$refs['navmenu'].scrollLeft;
      }
      this.popoverShow = distance ? true : false;

      //处于缩放状态
      if (document.getElementById('app').style.transform) {
        var scale = document.getElementById('app').style.transform.slice(6, -1);
        this.contTop = $(ev.target).position().top / scale + 119 + document.documentElement.scrollTop - this.$refs['navmenu'].scrollTop;
        this.contLeft = $(ev.target).position().left / scale - (158 - $(ev.target)[0].offsetWidth) / 2 - this.$refs['navmenu'].scrollLeft;
        var distance = this.$refs['navmenu'].offsetHeight - $(ev.target).position().top / scale + this.$refs['navmenu'].scrollTop >= 36;
        this.popoverShow = distance ? true : false;
      }
      // Bus.$emit('refrestPopover','t',item);
      // //更换时重置数据
      // var a = JSON.parse(JSON.stringify(this.content));
      // this.content = [];
      // this.content = a;
    },
    //鼠标离开li
    leaveTop () {
      this.inputCons = '';
      this.popoverShow = false;
      //延时解决向下离开li时li的背景色消失
      setTimeout(() => {
        if (!this.popoverShow) {
          //即没在li也没在浮层
          $('li').removeClass('backCurr');
        }
      }, 10)
    },
    //鼠标离开悬浮层
    leavePopover () {
      this.inputCons = '';
      this.popoverShow = false;
      $('li').removeClass('backCurr');
    },
    touchstarts (sub, ind, name) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.handleFetchChildren(sub, ind, name);
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmoves () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchends (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    },
    refeshMenu () {
      this.refeshMenus = true;
      this.marginLeft = 0;
    },
    //搜索结束
    openWin (nav) {
      var wH = (window.innerHeight / 2) - 100;
      if (nav.flowType == "flow") {
        if (nav.url) {
          var appid = nav.url.split('?appId=')[1];
          if (appid) {
            if (nav.url.indexOf(window.location.pathname) > -1) {
              // this.$router.replace({ name: 'Next', query: { appId: appid } });
              this.routerJump('replace','Next',{ appId: appid },nav.name);
            } else {
              // window.location.href = nav.url;
              this.open(nav.url,'_self',nav.name);
            }
          } else {
            // window.location.href = nav.url;
            this.open(nav.url,'_self',nav.name);
          }

        } else {
          this.$notify({
            position: 'top-right',
            title: '提示',
            message: '该流程暂无外展平台',
            type: 'warning',
            offset: wH
          });
        }
      }
      if (nav.flowType == "block") {
        if (nav.wzUrl) {
          // window.location.href = nav.wzUrl;
          this.open(nav.wzUrl,'_self',nav.name);
        } else if (nav.pageUrl) {
          // window.location.href = nav.pageUrl;
          this.open(nav.pageUrl,'_self',nav.name);
        } else {
          this.$notify({
            position: 'top-right',
            title: '提示',
            message: '该流程暂无外展平台',
            type: 'warning',
            offset: wH
          });
        }
      }

    },
    handleSwitchMore (child, ind, name) {
      if (name == '更多') {
        child.showMore = true;
      } else {
        child.showMore = false;
      }
    },
    //请求下级
    handleInsertFlowChild (sub, type,ev,sind) {
      const _this = this;
      if (sub.name == '更多' || sub.name == '收起' || (sub.appId != 'cpsqjgpt' && sub.appId != 'cpsqfl')) return;
      // if (sub.name == '更多' || sub.name == '收起' || new RegExp("^sqsjyxglzpt.*$").test(sub.appId) || new RegExp("^orgic.*$").test(sub.appId)) return;
      _this.getTop(ev,sind,sub);
      if (_this.getCanExpireLocal(sub.name + sub.id)) {
        _this.flowNavList = _this.getCanExpireLocal(sub.name + sub.id);
      } else {
        _this.flowNavList = [{ name: '正在加载...' }];
        _this.$http
          .get(
            "/zciid-deliverable/showPlatformStyle/flow/api/getFloorSubContentByFlowId.json",
            {
              appId: _this.$appId,
              flowId: sub.id || "",
              pageSize: 100,
              pageNum: 1
            }
          )
          .then(res => {
            if (res.state == 1) {
              _this.flowNavList = res.data;
              if (!res.data.length) {
                _this.flowNavList = [{ name: '暂无数据' }];
                return;
              }
              _this.setCanExpireLocal(sub.name + sub.id, _this.flowNavList, 600000);
            } else {
              _this.flowNavList = [{ name: '暂无数据' }];
            }
          })
      }
      
    },
    handleInsert (it, ind) {
      if (it.hasC) {
        return false;
      }
      this.$http
        .get(
          "/zciid-deliverable/showPlatformStyle/flow/api/get/getFlowFloorNavList.json",
          {
            appId: this.$appId,
            flowId: it.id
          }
        )
        .then(res => {
          if (res.state == 1) {
            it.hasC = true;
            this.flowNavList.splice(ind + 1, 0, ...res.data.subNavArr);
            this.flowNavList.splice(
              ind + 1 + res.data.subNavArr.length,
              0,
              ...res.data.blockArr
            );
          }
        });
    },
    computedNum(){
      //计算能放几个优先级流程
      var width=0,wrapIndex=this.NavList.length;
      for (let t = 0; t < this.NavList.length; t++) {
        const spanWidths = this.NavList[t].name.length * 16 + 20;
        width += spanWidths;
        if(width + 145 > this.$refs.navbarUl.offsetWidth){
          wrapIndex = t;
          break;
        }
      }
      this.mainNavListMore = JSON.parse(JSON.stringify(this.NavList)).slice(wrapIndex,JSON.parse(JSON.stringify(this.NavList)).length);
      this.tempMainNavList = JSON.parse(JSON.stringify(this.NavList)).slice(0,wrapIndex);
    },
    getSubNav () {
      this.$http
        .get(
          "/zciid-deliverable/showPlatformStyle/flow/api/get/getFlowFloorNavList.json",
          {
            // ...this.$route.query
            appId: this.$appId,
            flowId: ""
          }
        )
        .then(res => {
          if (res.state == 1) {
            //区分前三位
            res.data.subNavArr.forEach((ele) => {
              ele.level = 1;
            })
            this.initSubNavList = JSON.parse(JSON.stringify(res.data.subNavArr));
            this.subNavList = res.data.subNavArr;
            this.thirdItem = res.data.subNavArr[2];
            this.getcheckedNav(true);
          }
        });
    },
    //获取勾选优先级
    getcheckedNav (flag) {
      this.$http
        .get(
          "/zciid-deliverable/showPlatformStyle/flow/api/get/getMainTopNavList.json",
          {
            appId: this.$appId,
            types: "sub-nav-priority",
            flowId: this.$route.query.flowId || ""
          }
        )
        .then(res => {
          if (res.state == 1) {
            if (flag) {
              this.moreList = res.data;
              //区分第一级
              res.data.forEach((ele) => {
                ele.level = 2
              })
              this.subNavLists=res.data;
              
              this.$nextTick(()=>{
                this.findWrapIndex();
              })
            } else {
              this.flowNavList = res.data;
            }
          }
        });
    },
    //点击更多按钮，显示勾选优先级
    resetCheckedNav () {
      this.mainMoreShow = false;
      this.dropShow = !this.dropShow;
      // this.getcheckedNav(false);
    },
    flowWidths () {
      var fwid = 0;
      $('.menuBar>span').each((index, ele) => {
        fwid += $(ele).width();
      })
      return fwid;
    },
    handleSwitch (type) {
      if (type == "right") {
        if (this.marginLeft + this.flowWidths() > this.deviceWidth + 176) {
          this.marginLeft -= 50;
        }
      }
      if (type == "left") {
        if (this.marginLeft < 0) {
          this.marginLeft += 50;
        }
      }
    },
    handleEnterSubNav (sub, ind, type = "") {
      if (sub.flowType == 'flow') {
        this.subChildrenShow = true;
      }
      if (this.getCanExpireLocal(sub.name + sub.id)) {
        this.flowChildList = this.getCanExpireLocal(sub.name + sub.id);
      } else {
        this.loadingShow = true;
        this.subInd = ind;
        this.handleFetchChildren(sub, ind, 'subNav')
      }
    },
    handleFetchChildren (sub, key, type = "") {
      if (type != "MainsubNav") {
        this.$emit("changeSubInd", key);
      }

      if (sub.flowType != "flow") {
        this.loadingShow = false;
        return false;
      }
      this.flowChildList = [];
      this.$http
        .get(
          "/zciid-deliverable/showPlatformStyle/flow/api/getFloorSubDataByFlowId.json",
          {
            flowId: sub.id || "",
            appId: this.$appId,
          }
        )
        .then(res => {
          this.loadingShow = false;
          if (res.state == 1) {
            if (res.data.length != 0) {
              this.flowChildList = this.handleFilterBlock(sub, res.data);
              this.setCanExpireLocal(sub.name + sub.id, this.flowChildList, 600000);
            }
          }
        });
    },
    //更多以及收起处理
    handleFilterBlock (sub, list) {
      var allboxWid = (this.deviceWidth + 115) * 2 - 276;
      // if (list[0].flowType == 'flow') {
      return list.map((second, index) => {
        if (second.dataArray.length) {
          let fwid = 0;
          let start = 0;
          second.dataArray.map((three, ind) => {
            fwid += (((three.name.length * 14 + 28) > 90) ? (three.name.length * 14 + 28) : 90);
            if (fwid <= this.deviceWidth + 115 && fwid >= this.deviceWidth + 23) {
              fwid = this.deviceWidth + 115;
            }
            if (fwid < allboxWid) {
              three.isMore = false;
            } else {
              if (start == 0) {
                start = ind;
              }
              three.isMore = true;
            }
            return three;
          });
          if (start != 0) {
            (second.dataArray.splice(start, 0, { name: '更多', flowType: 'switch', show: true }), second.dataArray.push({ name: '收起', flowType: 'switch', show: false }))
          };
        }
        second.showMore = false;
        return second;
      })

    },
    getPageTitle () {
      this.$http
        .get(
          "/acnid-project-approve/circleuser/open/selectUserInfoByAppIdOrCircleId.json",
          {
            ...this.$route.query
          }
        )
        .then(res => {
          if (res.state == 1 && res.data) {
            this.$store.commit('setAssistUserId', res.data);
          }
        });
    },
    //查询左上角logo、文字信息
    getLogoIcon () {
      this.$http
        .get("/zciid-deliverable/business/bAppOqmidPage/getDataForOqimd.json", {
          appId: this.$appId
        })
        .then(res => {
          if (res.state == 1) {
            window.$appName = res.data.appName ? res.data.appName : '';
            window.document.title = res.data.copyRightTitle ? res.data.copyRightTitle : (res.data.appName ? res.data.appName : '共享世界');
            this.logoUrl = res.data.mainLogoUrl
              ? res.data.mainLogoUrl
              : "javascript:;";
            this.logo = res.data;
            this.logoImg = res.data.mainLogoImg ? `url(${res.data.mainLogoImg})` : (!res.data.mainLogoName && !res.data.mainLogoImg ? `url('http://520emv.com/cme-sso-app/showimg/648638977896648704.png')` : '')
            window.$logoName = res.data.mainLogoName;
            if (res.data.themeColor) {
              // 设置主题颜色
              window.document.documentElement.setAttribute(
                "data-theme",
                this.$store.state.NewYearTheme ? this.$store.state.NewYearTheme : res.data.themeColor //过年主题
              );
            }
          } else {
            window.document.title = "共享世界"
            window.$logoName = ''
          }
          this.logo.mainLogoEnName = this.logo.mainLogoEnName?this.logo.mainLogoEnName:'带你走进元宇宙';
          this.logo.mainLogoName = this.logo.mainLogoName?this.logo.mainLogoName:(!this.logo.mainLogoName&&!this.logo.mainLogoImg ? '共享世界':'')
        })
        .catch(res=>{
          this.logo.mainLogoEnName = '带你走进元宇宙';
          this.logo.mainLogoName = '共享世界';
        })
      
    },
    handleFocus () {
      // this.searchTopBoxShow = !this.searchTopBoxShow;
      // this.mainMoreShow = false;
      // this.searchBoxShow = false;
      this.popShow('searchTopBoxShow');
      this.keyWord = '';
      this.haveChildMenu = [];
      // this.open('https://520plaza.com/?server=' + window.location.hostname, '_blank','搜索');
    }
  }
};
</script>
<style lang="scss">
@import "~@/assets/css/theme/index.scss";
@import "~@/assets/css/header.scss";
</style>
<style scoped>
/* 过年主题 */
/* .li.nav a,.logo .mainLogo,.logo .Metaverse,.div span{
    color: #fff !important;
  }
  .nav:hover{
    background-color: #d60000 !important;
  }
  .navmenu .z-container ul li:hover{
    background-color: #e62020 !important;
  } */
/* 过年主题 */
.leftBox{
  /* display:flex; */
  position:relative;
  height:36px;
  /* white-space:nowrap; */
  overflow:hidden;
  /* width:calc(100% - 158px); */
}
.navigationConfig{
  display: flex;
  align-items: center;
  width: 140px;
}
.navigationConfig .navigationConfig-l{
  background: url("../assets/images/icons/configuration_white_19.png") no-repeat 10px 7px;
}

.navigationConfig .navigationConfig-line{
  display: inline-block;
  margin: 0 5px;
  border-left: 1px solid #eee;
  height: 20px;
}
.navigationConfig .navigationConfig-r{
  background: url("../assets/images/icons/search_white_16.png") no-repeat 11px 9px;
}
.navigationConfig .navigationConfig-m{
  text-align: center;
  line-height: 36px;
  color: white;
}
.navigationConfig-l,.navigationConfig-r,.navigationConfig-m{
  position: relative;
  display: inline-block;
  width: 40px;
  height: 36px;
  cursor: pointer;
}
.navigationConfig-l:hover,.navigationConfig-r:hover,.navigationConfig-m:hover{
  background-color: #4499de;
  /* 过年主题 */
  /* background-color: #e62020 !important; */
}
@media screen   and (max-width: 365px){
  .navigationConfig .navigationConfig-line{
    margin: 1px;
  }
  .navigationConfig{
    width: 95px;
  }
  .navigationConfig-l{
    width: 36px;
  }
  .navigationConfig-r{
    width: 23px;
    background-position: 3px 9px !important;
  }
}
.textIndent {
  padding-left: 15px !important;
}
.loading {
  width: 100%;
  height: 50px;
  text-align: center;
  margin: 60px 0; 
}
.selcctChoice {
  position: absolute;
  right: -18px;
  top: 13px;
  cursor: pointer;
}
.selects {
  width: 160px;
  border: 1px solid #aaa;
  background-color: #fff;
  box-sizing: border-box;
  position: absolute;
  right: 0;
  top: 35px;
  z-index: 9999999;
}
.selects span {
  display: block;
  padding: 4px;
}
.selects input {
  width: 100%;
  padding: 4px !important;
  border: 1px solid #aaa;
}
.selects>ul {
  height: 200px;
  overflow-y: auto;
}
.selects ul li {
  padding: 6px;
}
.changeColor {
  background-color: #5897fb !important;
  color: white;
  /* 过年主题 */
  /* background-color: #ee8785 !important; */
}
.changeColors:hover {
  background-color: #5897fb !important;
  color: white;
  /* 过年主题 */
  /* background-color: #ee8785 !important; */
}
/* .selects ul li:first-child {
  background-color: #ddd;
} */
.backCurr::after {
  content: "";
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #fff;
  position: absolute;
  left: 47%;
  top: 32px;
  z-index: 999;
}
.z-container {
  position: relative;
}
.popover {
  position: absolute;
  width: 158px;
  height: 230px;
  top: 200px;
  z-index: 999999;
}
.popoverWhite {
  position: absolute;
  left: 0;
  bottom: 0;
  background-color: #fff;
  width: 100%;
  height: calc(100% - 10px);
  box-shadow: 0 0 10px rgb(0 0 0 / 20%);
}
.popoverWhite > span {
  display: block;
  padding: 5px;
}
.popoverWhite > span > input {
  width: 100%;
  padding: 4px;
  border: 1px solid #aaa;
}
.popoverWhite > div {
  overflow-y: auto;
  height: calc(100% - 36px);
}
</style>
<style >
.select2-container--default .select2-selection--single {
  border: 0 none;
  background: transparent;
  opacity: 0;
}
.select2-container--open .select2-dropdown--below {
  border-top: 1px solid #ddd;
}
.select2-container--open .select2-dropdown {
  width: 120px !important;
}
.select2-container {
  position: absolute;
  top: 0;
  left: -10px;
  height: 45px;
}
.logo {
  position: relative;
}
.logo .mainLogo {
  padding: 0 3px 0 5px;
}
.logo .mainLogoName {
  font-size: 20px;
  height: 26px;
  max-width: 182px;
  overflow: hidden;
}
.logo .mainLogoEnName {
  font-size: 12px;
  height: 18px;
  max-width: 160px;
  overflow: hidden;
}
.logo .Metaverse {
  border-left: 1px dashed #666;
  padding-left: 10px;
  /* 过年主题 */
  /* border-left: 1px dashed #fff; */
}
.logo .Metaverse div:first-child {
  font-size: 20px;
}
.logo .MetaverseUrl {
  font-size: 12px;
  max-width: 100px;
  overflow: hidden;
}
.logo .picture {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 44px;
  height: 44px;
}
.logo a:hover {
  color: black;
}
.chinese {
  width: 50px;
  height: 19px;
  line-height: 19px;
  text-align: center;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  background-color: #258efd;
  font-size: 12px;
  color: #fff;
  position: relative;
  margin-left: 13px;
}
.chinese:after {
  content: "";
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 5px solid #258efd;
  position: absolute;
  top: 5px;
  right: 100%;
  /* margin-right: -8px; */
}
/* 搜索开始 */
.search_box {
  position: absolute;
  right: -10px;
  top: 60px;
  z-index: 9;
  width: 561px;
  padding: 1px 0px;
  background: #ffffff;
  border: 1px solid #1870b8;
}
.search_box .search_1 {
  width: 130px;
  height: 36px;
  cursor: pointer;
  border-right: 1px solid #ccc;
}
.search_box .search_1 .search_zhongji {
  width: 110px;
  height: 36px;
  display: inline-block;
  background: url("~@/assets/images/icons/logo_zj.png") center no-repeat;
  padding: 0 !important;
}
.search_box .search_1 .search_baidu {
  width: 130px;
  height: 36px;
  display: inline-block;
  background: url("~@/assets/images/icons/logo_baidu.png") center no-repeat;
}
.search_box .search_1 .search_sougou {
  width: 130px;
  height: 36px;
  display: inline-block;
  background: url("~@/assets/images/icons/logo_sougou.png") center no-repeat;
}
.search_box .search_1 .search_360 {
  width: 130px;
  height: 36px;
  display: inline-block;
  background: url("~@/assets/images/icons/logo_360.png") center no-repeat;
}
.search_box .search_1 .search_bing {
  width: 130px;
  height: 36px;
  display: inline-block;
  background: url("~@/assets/images/icons/logo_bing.png") center no-repeat;
}
.search_box .search_1 span {
  width: 18px;
  height: 36px;
  display: inline-block;
  background: url("~@/assets/images/icons/icon_search_arrow.png") center center
    no-repeat;
}
.search_box .search_1 .search_menu {
  width: 128px;
  position: absolute;
  background: #fff;
  top: 39px;
  left: 0;
  border-width: 1px 1px 0 1px;
  border-color: #ccc #ccc transparent #ccc;
  border-style: solid solid none solid;
  overflow: hidden;
  font-size: 0;
}
.search_box .search_1 .search_menu a {
  width: 130px;
  height: 39px;
  display: inline-block;
  border-bottom: 1px solid #ccc;
  background-repeat: no-repeat;
  background-position: center;
}
.search_box .search_1 .search_menu a.search_baidu {
  background: url("~@/assets/images/icons/logo_baidu.png") center no-repeat;
}
.search_box .search_1 .search_menu a.search_sougou {
  background: url("~@/assets/images/icons/logo_sougou.png") center no-repeat;
}
.search_box .search_1 .search_menu a.search_360 {
  background: url("~@/assets/images/icons/logo_360.png") center no-repeat;
}
.search_box .search_2 {
  width: 285px;
  height: 36px;
}

.search_box .search_2 input {
  width: 280px;
  height: 36px;
  line-height: 36px;
  padding: 0 5px;
  font-size: 14px;
  color: #333;
  border: none;
}
.search_box .search_2 .search_list {
  width: 278px;
  position: absolute;
  overflow: auto;
  max-height: 120px;
  float: left;
  text-overflow: ellipsis;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #ccc;
  border-top: none;
}
/*width:258px;*/
.search_box .search_2 .search_list li {
  padding: 0 10px;
  width: 258px;
  line-height: 26px;
  font-size: 14px;
  overflow: hidden;
  text-decoration: none;
  float: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  outline: none;
}
.search_box .search_2 .search_list li.curr {
  background: #eee;
}
.search_box .search_2 .search_list li:hover a {
  color: #258efd;
}
.search_box .search_3 {
  width: 100px;
  height: 36px;
}
#cme-header .navbar .search_box .search_3 a {
  border: 0 none;
  padding: 0;
  width: 100px;
  height: 36px;
  line-height: 36px;
  font-size: 18px;
  color: #fff;
  text-align: center;
  display: inline-block;
  border-radius: 2px;
  background: #1870b8;
}
.search_box .close_btn {
  cursor: pointer;
  display: inline-block;
  height: 23px;
  width: 23px;
  margin: 7px 7px 0px 15px;
  background: url("~@/assets/images/icons/header_search_gb.png") no-repeat;
}
.searchBox{
  width: 300px;
  border-radius: 4px;
}
.searchBox .child-menu-search{
  overflow: auto;
  height: 209px;
  position: relative;
  box-sizing: border-box;
  color: #606266;
  border-top: 1px solid #ddd; 
}
.searchBox .child-menu-search .menuitem{
  padding: 0 10px;
  text-align: justify;
	text-overflow: ellipsis;
	word-break: break-all;
}
.searchBox .searchBox-input{
  margin:0 auto;
  width:100%;
  height: 46px;
  position:relative;
  border-radius:5px;
  border:0;
}
.searchBox .searchBox-input span{
  position: absolute;
  display: inline-block;
  right: 20px;
  top: 15px;
  background: url("../assets/images/icons/search_blue_16.png") no-repeat;
  width: 16px;
  height: 16px;
  vertical-align: middle;
  cursor: pointer;
}
.searchBox .searchBox-input input{
  width:calc(100% - 67px);
  height:46px;
  margin-left:10px;
  border:0;  
  color:#333;
}
.searchBox .searchBox-input input::-webkit-input-placeholder{
  color:#999;
}
.searchBox .searchBox-input input:-moz-placeholder{
  color:#999;
}
.searchBox .searchBox-input input::-moz-placeholder.searchBox{
  color:#999;
}
.searchBox .searchBox-input input::-ms-input-placeholder{
  color:#999;
}
.mainMoreS{
  position:absolute;
  right:0;
  top:54px;
  z-index:8000;
  background:#ffffff;
  border: 1px solid #dddd;
}
.assistantMoreS{
  top:36px
}
.more-child .child-menu {
  overflow: auto;
  position: relative;
  box-sizing: border-box;
  color: #606266;
  border-right: solid 1px #e4e7ed;
  min-width: 128px;
  max-width: 160px;
  width: auto;
}

.more-child .child-menu .child-menu__wrap {
  /* margin-bottom: -17px;
  margin-right: -17px; */
  height: 168px;
  /* overflow: scroll; */
}

.child-menu_list {
  position: relative;
  padding: 6px 0;
  list-style: none;
  min-height: auto;
  box-sizing: border-box;
  border-bottom: 1px solid #ddd;
  border-bottom: none;
}

.child-menu_list .menuitem {
  padding-right: 0;
  cursor: pointer;
  padding: 0;
  position: relative;
  display: flex;
  align-items: center;
  height: 28px;
  line-height: 28px;
  outline: 0;
}
.child-menu_list .menuitem:hover {
  color: #1777c6;
}
.child-menu_list .menuitem.curr {
  background: #f5f7fa;
  color: #333;
}
.child-menu_list .menuitem span {
  padding: 0 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#cme-header .subnav {
  /* 过年主题 */
  /* background-color: #c42f2c; */
  background-color: coral;
}
#cme-header .navbar .more{
    float: right;
  }
.subnav > .z-container {
  position: relative;
}
.subnav .z-container .right {
  position: absolute;
  right: 0px;
  top: 0;
  padding-right: 36px;
}

.subnav .z-container .right .li.process-more {
  position: relative;
  right: 0;
}
.subnav .z-container .left {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  /* overflow: hidden; */
  display: flex;
}
</style>

<style >
/*共享世界头尾响应式  开始*/
.nav-center.header .z-container{
  display: flex;
}
.nav-center .toolbar .drop {
  display: none;
}
.nav-center .top-left .layer-box {
  z-index: 10000;
}
#cme-header .navbar-box .navbar-icon {
  display: none;
}
#cme-header .navbar-box .close {
  display: none;
}
#cme-header .subnav .cme-center .arrow-left {
  display: none;
}
#cme-header .subnav .cme-center .arrow-right {
  display: none;
}
.nav-center .toolbar {
  float: left;
  position: relative;
}
@media screen   and (max-width: 767px) {
  #cme-header .navmenu ul {
    width: 100% !important;
  }
  #cme-header .logo {
    max-width: 230px;
  }
  .logo .picture {
    width: 34px;
    height: 34px;
  }
  .logo .mainLogoName {
    font-size: 18px;
    /* max-width: 108px; */
  }
  .logo .mainLogoEnName {
    font-size: 12px;
    height: 18px;
    max-width: 83px;
    white-space: nowrap;
    overflow: hidden;
  }
  .logo .Metaverse {
    padding-left: 5px;
    border-left: 1px dashed #666;
    /* 过年主题 */
    /* border-left: 1px dashed #fff; */
  }
  .logo .Metaverse div:first-child {
    font-size: 18px;
  }
  .logo .MetaverseUrl {
    font-size: 12px;
    max-width: 54px;
    overflow: hidden;
    margin-top: 2px;
  }
  
  #cme-header .navbar li {
    margin-left: 0;
  }
  #cme-header .navbar-box .navbar-icon {
    display: block;
    margin-top: 23px;
  }
  #cme-header .navbar-box .navbar-icon a {
    display: block;
    width: 24px;
    height: 24px;
    background: url(~@/assets/image/images/icons/navbox_navbar_icon.png)
      no-repeat;
  }
  #cme-header .navbar-box .navbar-mask {
    position: fixed;
    top: 36px;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 800;
  }
  #cme-header .navbar .navbar-libox.phone {
    position: fixed;
    top: 36px;
    bottom: 0;
    right: 0;
    width: 166px;
    background: #fff;
    z-index: 801;
    padding: 30px 30px;
    text-align: center;
    overflow-y: auto;
  }
  #cme-header .navbar .navbar-libox.phone .close {
    display: block;
    position: fixed;
    top: 46px;
    right: 201px;
    z-index: 802;
    cursor: pointer;
  }
  #cme-header .navbar .navbar-libox.phone .close img {
    width: 14px;
  }
  #cme-header .navbar .navbar-libox.phone .nav {
    display: block;
    margin-bottom: 2px;
    width: 100%;
    margin-left: 0;
    text-align: left;
    padding: 0;
  }
  #cme-header .navbar a {
    font-size: 14px;
  }
  #cme-header .navbar .navbar-libox.phone .li .nav-nemu {
    left: 0;
  }
  .nav-center .toolbar .exit {
    display: none;
  }
  .nav-center .toolbar .line {
    display: none;
  }
  .nav-center .toolbar .drop {
    display: block;
    float: right;
    width: 16px;
    height: 23px;
    margin: 13px 3px 0 0;
    cursor: pointer;
    background: url(~@/assets/image/images/icons/toolbar_drop_icon.png)
      no-repeat;
  }
  .nav-center .toolbar.hover .toolbarbox {
    display: block;
    width: 74px;
    background: #fff;
    border: 1px solid #ddd;
    padding: 0 8px;
    position: absolute;
    right: 0;
    top: 36px;
    z-index: 1;
  }
  .nav-center .toolbar.hover .toolbarbox .exit {
    display: block;
  }
  .nav-center .toolbar.hover .toolbarbox .line {
    display: block;
  }
  /* .nav-entrance {
    position: unset !important;
  } */
  .nav-center .toolbar {
    position: unset !important;
  }
  .layer-box {
    left: 20px !important;
    right: 0 !important;
    width: auto !important;
  }

  .more-child .child-menu .child-menu__wrap {
    margin-bottom: 0px;
    margin-right: 0px;
  }
  .search_box {
    width: 100vw;
    padding: 4px 0px;
    top: 46px;
  }

  .search_box .search_1 {
    width: 120px;
    margin-left: 2px;
  }
  .search_box .search_1 .search_zhongji {
    width: 100px;
  }
  .search_box .search_1 .search_menu {
    width: 120px;
    top: 44px;
  }
  .search_box .search_1 .search_menu a {
    width: 120px;
    background-position: left;
  }
  .search_box .search_2 {
    width: 180px;
  }
  .search_box .search_2 input {
    width: 180px;
  }
  .search_box .search_3 {
    width: 40px;
    margin: 0px 0;
  }
  #cme-header .navbar .search_box .search_3 a {
    width: 40px;
    font-size: 12px;
  }
  .search_box .close_btn {
    margin: 7px 0px 0px 5px;
  }
}

@media screen and (min-width: 768px) and (max-width: 992px) {
  #cme-header .navbar-box .navbar-icon {
    display: block;
    margin-top: 23px;
  }
  #cme-header .navbar-box .navbar-icon a {
    display: block;
    width: 24px;
    height: 24px;
    background: url(~@/assets/image/images/icons/navbox_navbar_icon.png)
      no-repeat;
  }
  #cme-header .navbar-box .navbar-mask {
    position: fixed;
    top: 36px;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 800;
  }
  #cme-header .navbar .navbar-libox.phone {
    position: fixed;
    top: 36px;
    bottom: 0;
    right: 0;
    width: 166px;
    background: #fff;
    z-index: 801;
    padding: 30px 30px;
    text-align: center;
    overflow-y: auto;
  }
  #cme-header .navbar .navbar-libox.phone .close {
    display: block;
    position: fixed;
    top: 46px;
    right: 201px;
    z-index: 802;
    cursor: pointer;
  }
  #cme-header .navbar .navbar-libox.phone .close img {
    width: 14px;
  }
  #cme-header .navbar .navbar-libox.phone .nav {
    display: block;
    margin-bottom: 2px;
    width: 100%;
    margin-left: 0;
    text-align: left;
    padding: 0;
  }
  #cme-header .navbar a {
    font-size: 14px;
  }
  #cme-header .navbar .navbar-libox.phone .li .nav-nemu {
    left: 0;
  }
  /* .nav-entrance {
    position: unset !important;
  } */
  .nav-center .toolbar {
    position: unset !important;
  }
  .layer-box {
    left: 20px !important;
    right: 0 !important;
    width: auto !important;
  }
}
@media screen   and (max-width: 332px) {
  .navbar li a {
    padding: 2px 0 !important;
  }
  #cme-header .subnav .li {
    padding: 0 4px;
  }
}
@media screen and (min-width: 333px) and (max-width: 352px) {
  .navbar li a {
    padding: 2px 1px !important;
  }
}
@media screen   and (max-width: 400px) {
  .navbar li a {
    padding: 2px 0 !important;
  }
  #cme-header .subnav .li {
    padding: 0 4px;
  }
  #cme-header .navbar .nav a { 
    padding:2px 0 !important; 
  }
}
@media screen and (min-width: 992px) and (max-width: 1199px) {
  #cme-header .navbar-box .navbar-icon {
    display: block;
    margin-top: 23px;
  }
  #cme-header .navbar-box .navbar-icon a {
    display: block;
    width: 24px;
    height: 24px;
    background: url(~@/assets/image/images/icons/navbox_navbar_icon.png)
      no-repeat;
  }
  #cme-header .navbar-box .navbar-mask {
    position: fixed;
    top: 36px;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 800;
  }
  #cme-header .navbar .navbar-libox.phone {
    position: fixed;
    top: 36px;
    bottom: 0;
    right: 0;
    width: 166px;
    background: #fff;
    z-index: 801;
    padding: 30px 30px;
    text-align: center;
    overflow-y: auto;
  }
  #cme-header .navbar .navbar-libox.phone .close {
    display: block;
    position: fixed;
    top: 46px;
    right: 201px;
    z-index: 802;
    cursor: pointer;
  }
  #cme-header .navbar .navbar-libox.phone .close img {
    width: 14px;
  }
  #cme-header .navbar .navbar-libox.phone .nav {
    display: block;
    margin-bottom: 10px;
    width: 100%;
    margin-left: 0;
    text-align: left;
    padding: 0;
  }
  #cme-header .navbar a {
    font-size: 14px;
  }
  #cme-header .navbar .navbar-libox.phone .li .nav-nemu {
    left: 0;
  }
  /* .nav-entrance {
    position: unset !important;
  } */
  .nav-center .toolbar {
    position: unset !important;
  }
  .layer-box {
    left: 20px !important;
    right: 0 !important;
    width: auto !important;
  }
}
</style>
<style lang="scss" scoped>
@media screen   and (max-width: 345px) {
  .plus-icon,.nav-search{
    display: none !important;
  }
}
.FontSizeZoomWholeAndroid2,.FontSizeZoomWhole2{
  .navbar-libox .li.nav:first-of-type{
    @media screen   and (max-width: 440px) {
      display: none !important;
    }
  }
  .plus-icon{
    @media screen   and (max-width: 355px) {
      display: none !important;
    }
  }
}
.FontSizeZoomWholeAndroid3,.FontSizeZoomWhole3{
  .navbar-libox .li.nav:first-of-type{
    @media screen   and (max-width: 480px) {
      display: none !important;
    }
  }
  .plus-icon{
    @media screen   and (max-width: 416px) {
      display: none !important;
    }
  }
  .nav-search{
    @media screen   and (max-width: 360px) {
      display: none !important;
    }
  }
}
.FontSizeZoomWholeAndroid4,.FontSizeZoomWhole4{
  .navbar-libox .li.nav:first-of-type{
    @media screen   and (max-width: 520px) {
      display: none !important;
    }
  }
  .plus-icon{
    @media screen   and (max-width: 450px) {
      display: none !important;
    }
  }
  .nav-search{
    @media screen   and (max-width: 405px) {
      display: none !important;
    }
  }
}
.FontSizeZoomWholeAndroid5,.FontSizeZoomWhole5{
  .navbar-libox .li.nav:first-of-type{
    @media screen   and (max-width: 570px) {
      display: none !important;
    }
  }
  .plus-icon{
    @media screen   and (max-width: 500px) {
      display: none !important;
    }
  }
  .nav-search{
    @media screen   and (max-width: 455px) {
      display: none !important;
    }
  }
}
.FontSizeZoomWholeAndroid6,.FontSizeZoomWhole6{
  .navbar-libox .li.nav:first-of-type{
    @media screen   and (max-width: 609px) {
      display: none !important;
    }
  }
  .plus-icon{
    @media screen   and (max-width: 540px) {
      display: none !important;
    }
  }
  .nav-search{
    @media screen   and (max-width: 480px) {
      display: none !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue